/** @flow */
import {
  FlexZoomCommandResponse,
  GetAssetsPathFuidsMessage,
  GetAssetsPathFuidsQuery,
  GetAssetsPathFuidsResponse,
  PathFuidsList,
  RepoItem
} from '../autogenerated/ZoomBridge';
import ParamsUtil from './ParamsUtil';
import HashMap from '../protocol/HashMap';
import $ from 'jquery';
import FileInfoUtil from './FileInfoUtil';
import _ from 'lodash';
import { injectIframe } from './DOMUtil';
import Storage from '../protocol/Storage';
import DownloadPageParams from './DownloadPageParams';
import { FlexDelete } from '../queries/lightbox/assets/FlexDelete';
import { FlexRemoteRename } from '../queries/lightbox/assets/FlexRemoteRename';
import { FlexRemoteMove } from '../queries/lightbox/assets/FlexRemoteMove';
import { getRemotePathFromBreadcrumb } from '../store/StoreUtil';
import ConnectionUtil from './session/ConnectionUtil';
import System from '../basic/System';
import StringUtil from './StringUtil';

const debug = require('../debug/debug')('wc:util:ThumbnailUtil');

export default class ThumbnailUtil {
  static DOWNLOAD_PAGE_URL: string = 'downloads/index.jsp';
  static HEAD_BRANCH = 'head';

  constructor() {}

  /**
   *
   * @param userId User Id
   * @param fullName Optional.
   * @return {string}
   */
  static avatar(userId: string, fullName: ?string = undefined): string {
    let avatarDc: number = Storage.get('AVATAR_DC');
    if (!avatarDc) {
      avatarDc = Date.now();
      Storage.set('AVATAR_DC', avatarDc);
    }

    let url = undefined;
    url = ParamsUtil.append(ConnectionUtil.getPreviewServerUrl() + '/review/api/user/avatar', {
      userId,
      _dc: avatarDc
    });

    url = ParamsUtil.appendAuthData(url);
    if (typeof fullName === 'string') {
      ``;
      url = ParamsUtil.append(url, { fullName });
    }
    return url;
  }

  /**
   *
   * @param userId User Id
   * @return {string}
   */
  static async fetchEmailAddress(userId: string): Promise<string> {
    let url = undefined;

    if (System.isBrowserApp()) {
      url = ParamsUtil.append(ConnectionUtil.getPreviewServerUrl() + '/review/api/user/emailId', {
        userId
      });
    } else {
      url =
        ConnectionUtil.getBaseUrl() +
        ConnectionUtil.DESKTOP_CONTEXT +
        ConnectionUtil.SECURE_REMOTE_CALL_SUFFIX +
        '/clientapi/user/emailid';
      url = ParamsUtil.append(url, { userId });
    }

    url = ParamsUtil.appendAuthData(url);
    const res = await $.ajax({
      url: url,
      contentType: false,
      method: 'GET',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    });
    return res.emailId;
  }

  /**
   * @return {string}
   * @private
   */
  static getExportCollectionAssetUrl(collectionId: number, type: string): string {
    return ConnectionUtil.getPreviewServerUrl() + '/review/api/collection/' + collectionId + '/export/' + type;
  }

  static getDownloadFolderUrl(assets: RepoItem[]): string {
    let exportUrl = ConnectionUtil.getPreviewServerUrl() + '/review/api/export/asset/zip?';

    exportUrl = ParamsUtil.append(exportUrl, {
      exportType: 'zip',
      bid: assets[0].getBid(),
      rrn: assets[0].getRrn()
    });

    assets.forEach((asset) => {
      exportUrl = ParamsUtil.append(exportUrl, {
        fuid: asset.getFuid()
      });
    });

    return exportUrl;
  }

  /**
   * Creates an export url for an collection asset
   * @param {Number} collectionId
   * @param {RepoItem} asset
   * @param {String} collectionName
   * @param {String} type ( "pdf", "zip")
   * @public
   */
  static createCollectionAssetExportUrl(
    collectionId: number,
    collectionName: string,
    asset: RepoItem,
    type: 'pdf' | 'zip'
  ): string {
    return this.createCollectionAssetSubsetExportUrl(collectionId, collectionName, asset ? [asset] : null, type);
  }

  /**
   * Creates an export url for a subset of a collection's assets
   * @param {Number} collectionId
   * @param {Array.<RepoItem>} assets
   * @param {String} collectionName
   * @param {String} type ( "pdf", "zip")
   * @public
   */
  static createCollectionAssetSubsetExportUrl(
    collectionId: number,
    collectionName: string,
    assets: ?Array<RepoItem>,
    type: 'pdf' | 'zip'
  ): string {
    let previewServerUrl: string = ThumbnailUtil.getExportCollectionAssetUrl(collectionId, type);
    if (assets && assets.length > 0) {
      previewServerUrl = ParamsUtil.append(previewServerUrl, {
        collectionName: collectionName, //If collectionName is null or undefined, it won't be sent.
        bid: assets[0].getBid()
      });

      assets.forEach((a) => {
        previewServerUrl = ParamsUtil.append(previewServerUrl, {
          fuid: a.getFuid(),
          rrn: a.getRrn(),
          fileName: a.getName()
        });
      });
    }
    return previewServerUrl;
  }

  static getUserFullnameUrl(userId: string): string {
    let url = undefined;

    if (System.isBrowserApp()) {
      const previewServerUrl = ConnectionUtil.getPreviewServerUrl();
      url = ParamsUtil.append(`${previewServerUrl}/review/api/user/fullname`, { userId });
    } else {
      url =
        ConnectionUtil.getBaseUrl() +
        ConnectionUtil.DESKTOP_CONTEXT +
        ConnectionUtil.SECURE_REMOTE_CALL_SUFFIX +
        '/clientapi/user/fullname';

      url = ParamsUtil.append(url, { userId });
    }
    //url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static isUserFullNameExist(userId: string): boolean {
    return ThumbnailUtil.userIdToFullNameMap.containsKey(userId);
  }

  static getFullNameFromCache(userId: string): string {
    return ThumbnailUtil.userIdToFullNameMap.get(userId);
  }

  static getZipDownloadCollectionUrl(collectionId: string): string {
    const previewServerUrl = ConnectionUtil.getPreviewServerUrl();
    let url = `${previewServerUrl}/review/api/collection/${collectionId}/export/zip/`;
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static getPdfDownloadCollectionUrl(collectionId: number): string {
    const previewServerUrl = ConnectionUtil.getPreviewServerUrl();
    let url = `${previewServerUrl}/review/api/collection/${collectionId}/export/pdf`;
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static getDownloadUrl(e: string): string {
    const previewServerUrl = ConnectionUtil.getPreviewServerUrl();
    let url = `${previewServerUrl}/review/api/download/${e}`;
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  /**
   * @type {HashMap}
   * @private
   */
  static userIdToFullNameMap = new HashMap();

  static userId2Promise = new HashMap();
  /**
   *
   * @param userId
   * @param tries
   * @return {Promise.<String>}
   */
  static loadUserFullName(userId: string): Promise<string> {
    debug('[loadUserFullName()] userId: ', userId);
    const existingPromise = this.userId2Promise.get(userId);
    if (existingPromise) {
      return existingPromise;
    }
    let getResponse;
    const prmise = new Promise(
      (getResponse = (resolve, reject, tries = 1) => {
        const fullName = ThumbnailUtil.getFullNameFromCache(userId);
        if (fullName && fullName !== userId) {
          // debug('[loadUserFullName()] found in cache: ', fullName);
          this.userId2Promise.remove(userId);
          resolve(fullName);
          return;
        } else {
          ThumbnailUtil.userIdToFullNameMap.put(userId, userId);
        }

        const url = ThumbnailUtil.getUserFullnameUrl(userId);
        debug('[loadUserFullName()] fetching from url: ', url);
        $.ajax({
          url,
          contentType: false,
          headers: ParamsUtil.createAuthHeaders(),
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          method: 'GET',
          success: function(data) {
            debug('[loadUserFullName()] res: ', data);
            if (data) {
              const fullName = data.fullName;
              if (fullName !== 'Anonymous') {
                ThumbnailUtil.userIdToFullNameMap.put(userId, fullName);
              }
              debug('[loadUserFullName()] fullName: ', fullName);
              resolve(fullName);
            } else {
              if (tries < 5) {
                getResponse(resolve, reject, tries + 1);
              } else {
                debug('[loadUserFullName()] error : Not Found');
                /** called resolve in case of reject to show userId instead of empty in place of fullname */
                resolve(userId);
              }
            }
          }
        })
          .fail(function(res, errorText, status) {
            let __errorMsg = StringUtil.isNotEmpty(status)
              ? status
              : StringUtil.isNotEmpty(errorText)
              ? errorText
              : 'Not Found';
            {
              if (tries < 5) {
                getResponse(resolve, reject, tries + 1);
              } else {
                debug('[loadUserFullName()] error: ', { res, errorText, status });
                /** called resolve in case of fail to show userId instead of empty in place of fullname */
                resolve(userId);
              }
            }
          })
          .always(() => {
            this.userId2Promise.remove(userId);
          });
      })
    );
    this.userId2Promise.put(userId, prmise);
    return prmise;
  }

  /**
   *
   * @param repoItem{RepoItem}
   * @return {string}
   */
  static createThumbUrl(repoItem: RepoItem): string {
    if (repoItem.getFrn() === 0) {
      return ThumbnailUtil.getFolderIcon();
    } else {
      return ThumbnailUtil.toThumbUrl(repoItem);
    }
  }

  /**
   *
   * @param {RepoItem} asset
   */
  static toThumbUrl(asset: RepoItem): string {
    if (!asset) {
      return '';
    }

    return ThumbnailUtil.getThumnailUrl(
      asset.getFrn() > 0,
      asset.getBid(),
      asset.getFuid(),
      asset.getRrn(),
      asset.getName(),
      asset.getFrn(),
      window.ARGS.collectionId
    );
  }

  static getThumnailUrl(
    isFile: boolean,
    bid: number,
    fuid: number,
    rrn: number,
    name: string,
    frn: number = -1,
    collectionId: number = 0
  ) {
    if (isFile) {
      let url = ThumbnailUtil.GET_THUMB_URL();
      url = ParamsUtil.appendAuthData(url);
      url = ParamsUtil.appendFuidBidRrnFrn(url, bid, fuid, frn, rrn, name);
      if (collectionId <= 0) {
        collectionId = window.ARGS.collectionId;
      }
      if (collectionId && collectionId > 0) {
        url = ParamsUtil.appendCollectionId(url, collectionId);
      }
      return url;
    } else {
      return ThumbnailUtil.getFolderIcon();
    }
  }

  static getFolderIcon(): string {
    return 'images/folder26X22.png';
  }

  /**
   * Url for the profile pic
   */

  static getProfilePicUrl(username: string): string {
    return ParamsUtil.appendAuthData(ParamsUtil.appendProfilePicTag(ThumbnailUtil.GET_THUMB_URL_OLD(), username));
  }

  static getHomeHeaderPicUrl(size: ?string = null): string {
    return ConnectionUtil.getPreviewServerUrl() + '/webclient/api/images/homeheader' + (size ? '/' + size : '');
  }

  static getLogoPicUrl(): string {
    return ConnectionUtil.getPreviewServerUrl() + '/webclient/api/images/logo';
  }

  static getLoginBackgroundImage(size: ?string = null): string {
    return ConnectionUtil.getPreviewServerUrl() + '/webclient/api/unsecure/images/loginbg' + (size ? '/' + size : '');
  }

  static getLoginBackgroundLogos(position: number): string {
    return ConnectionUtil.getPreviewServerUrl() + '/webclient/api/unsecure/images/loginoverlay/9/' + position;
  }

  static getFileTypeIcon(fileName: string, assetType: string): string {
    const previewServerUrl = ConnectionUtil.getPreviewServerUrl();
    return ParamsUtil.append(`${previewServerUrl}/webclient/api/images/filetype-icon`, {
      fileName: fileName,
      assetType: assetType
    });
  }

  static getURLToDownloadThisPath(path: string): string {
    return ParamsUtil.appendAuthData(ParamsUtil.appendURLToDownloadThisPath(ThumbnailUtil.GET_THUMB_URL_OLD(), path));
  }

  /**
   *
   * @param repoItem{repoItem}
   * @return {Promise}
   */
  static getScrubInfo(repoItem: RepoItem): Promise<string> {
    return new Promise((resolve: Function, reject: Function) => {
      const scrubInfo = ThumbnailUtil.getScrubInfoFromCache(repoItem);
      if (scrubInfo) {
        //resolve(scrubInfo);
        ThumbnailUtil.loadimage(repoItem, reject, scrubInfo, resolve);
      } else {
        $.ajax({
          contentType: false,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          url: ThumbnailUtil.createScrubInfoUrl(repoItem),
          success: (data) => {
            ThumbnailUtil.loadimage(repoItem, reject, data, resolve);
          },
          error: (error) => {
            reject(error);
          }
        });
      }
    });
  }

  static loadimage(repoItem: RepoItem, reject: Function, data: any, resolve: Function) {
    var img = document.createElement('img');
    img.src = ThumbnailUtil.createScrubUrl(repoItem);
    img.onerror = (err) => {
      reject(err);
      img = null;
    };
    img.onload = () => {
      ThumbnailUtil.storeScrubInfo(repoItem, data);
      resolve(data);
      img = null;
    };
  }

  /**
   *
   * @param repoItem{RepoItem}
   * @return {string}
   */
  static createScrubInfoUrl(repoItem: RepoItem): string {
    let previewServerUrl = ThumbnailUtil.getScrubUrl() + '/info';
    previewServerUrl = ThumbnailUtil.getBidFuidRrn(previewServerUrl, repoItem);
    previewServerUrl = ParamsUtil.appendAuthData(previewServerUrl);
    return previewServerUrl;
  }

  /**
   * @return {string}
   * @private
   */
  static getScrubUrl() {
    return ConnectionUtil.getPreviewServerUrl() + '/review/api/scrub';
  }

  static createScrubUrl(asset: RepoItem) {
    //return `/review/api/scrub?fuid=${asset.getFuid()}&bid=${asset.getBid()}&frn=${asset.getFrn()}&name=${asset.getName()}&zm_repo_id=${Authenticator.AUTH_DATA.repoId}&zm_username=${Authenticator.AUTH_DATA.username}&zm_cookie=${Authenticator.AUTH_DATA.cookie}&zm_server=${Authenticator.AUTH_DATA.serverUrl}`;
    let previewServerUrl = ThumbnailUtil.getScrubUrl();
    if (window.ARGS && window.ARGS.collectionId) {
      previewServerUrl = ParamsUtil.appendFuidBidRrnFrnCollectionId(
        previewServerUrl,
        asset.getBid(),
        asset.getFuid(),
        asset.getFrn(),
        asset.getRrn(),
        asset.getName(),
        window.ARGS.collectionId
      );
    } else {
      previewServerUrl = ParamsUtil.appendFuidBidRrnFrn(
        previewServerUrl,
        asset.getBid(),
        asset.getFuid(),
        asset.getFrn(),
        asset.getRrn(),
        asset.getName()
      );
    }

    previewServerUrl = ParamsUtil.appendAuthData(previewServerUrl);
    return previewServerUrl;
  }

  /**
   * Use this method to get the MP4 video url.
   * Calling this URL will generate the previews.
   * @param repoItem{repoItem}
   * @param size{number} Size in pixel for which preview generation has to be triggered. Zero for default size.
   * @return {string}
   */
  static createVideoPreviewUrl(repoItem: RepoItem, size: number = 0) {
    // Use the "interpolate" delimiter to create a compiled template.
    let compiled = _.template(ThumbnailUtil.H264_PREVIEW_URL);
    let url = compiled({ previewServer: ConnectionUtil.getPreviewServerUrl() });
    url = ThumbnailUtil.getBidFuidRrn(url, repoItem);
    if (window.ARGS && window.ARGS.collectionId) {
      url = ParamsUtil.appendCollectionId(url, window.ARGS.collectionId);
    }
    url = ParamsUtil.appendAuthData(url);
    if (size !== 0) {
      url = ParamsUtil.append(url, { size: size });
    }
    return url;
  }

  /**
   * Use this method to get the MP4 video url.
   * Calling this URL will generate the previews and return the information about generated previews.
   * Returned information from this will be in JSON format.<br>
   * Like:
   * <p>
   *     {
            "duration": 3530,//In milliseconds by default
            "defaultSize": 1080,//Video side.
            "width": 1920,//width
            "durationUnit": "MILLISECONDS",
            "availableSizes": [//Possible available sized on preview server.
                1080,
                720,
                520
            ],
            "height": 1080
          }
   *     }
   * </p>
   * @param repoItem{repoItem}
   * @param size{number} Size in pixel for which preview generation has to be triggered. Zero for default size.
   * @return {string}
   */
  static createVideoPreviewInfoUrl(repoItem: RepoItem, size: number = 0): string {
    // Use the "interpolate" delimiter to create a compiled template.
    let compiled = _.template(ThumbnailUtil.H264_PREVIEW_URL);
    let url = compiled({ previewServer: ConnectionUtil.getPreviewServerUrl() });
    url = url + '/info';
    url = ThumbnailUtil.getBidFuidRrn(url, repoItem);
    if (window.ARGS && window.ARGS.collectionId) {
      url = ParamsUtil.appendCollectionId(url, window.ARGS.collectionId);
    }
    url = ParamsUtil.appendAuthData(url);
    if (size !== 0) {
      ParamsUtil.append(url, { size: size });
    }
    return url;
  }

  /**
   * Use this method to get the preview of image.
   * Calling this URL will generate the previews.
   * @param repoItem{repoItem}
   * @return {string}
   */
  static createImagePreviewUrl(repoItem: RepoItem, pageNumber: number) {
    // Use the "interpolate" delimiter to create a compiled template.
    let compiled = _.template(ThumbnailUtil.IMAGE_PREVIEW_URL);
    let url = compiled({ previewServer: ConnectionUtil.getPreviewServerUrl() });
    url = ThumbnailUtil.getBidFuidRrn(url, repoItem);
    url = ParamsUtil.appendPageNumber(url, pageNumber);
    if (window.ARGS && window.ARGS.collectionId) {
      url = ParamsUtil.appendCollectionId(url, window.ARGS.collectionId);
    }
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static getBidFuidRrn(url: string, repoItem: RepoItem) {
    return ParamsUtil.appendFuidBidRrn(
      url,
      repoItem.getBid(),
      repoItem.getFuid(),
      repoItem.getRrn(),
      repoItem.getName()
    );
  }

  /**
   * Calling this URL will generate the previews and return the information about generated previews.
   * Returned information from this will be in JSON format.<br>
   * Like:
   * <p> {
   *             "width": 924,
   *             "height": 520,
   *             "size":1231,
   *             "extension":"PNG"
   *  }</p>
   * @param repoItem{repoItem}
   * @return {string}
   */
  static createImagePreviewInfoUrl(repoItem: RepoItem) {
    // Use the "interpolate" delimiter to create a compiled template.
    let compiled = _.template(ThumbnailUtil.IMAGE_PREVIEW_URL);
    let url = compiled({ previewServer: ConnectionUtil.getPreviewServerUrl() });
    url = url + '/info';
    url = ThumbnailUtil.getBidFuidRrn(url, repoItem);
    url = ParamsUtil.appendMediaType(url, FileInfoUtil.getMediaType(repoItem));
    url = ParamsUtil.appendResolution(url, ThumbnailUtil.DEFAULT_RESOLUTION);
    if (window.ARGS && window.ARGS.collectionId) {
      url = ParamsUtil.appendCollectionId(url, window.ARGS.collectionId);
    }
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static createJobProgressInfoUrl(jobId: number) {
    // Use the "interpolate" delimiter to create a compiled template.
    let compiled = _.template(ThumbnailUtil.JOB_STATUS_URL);
    let url = compiled({ previewServer: ConnectionUtil.getPreviewServerUrl() });
    url = url + '/progress';
    url = ParamsUtil.appendJobId(url, jobId);
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  /**
   *
   * @param repoItem{repoItem}
   * @return {*}
   */
  static getScrubInfoFromCache(repoItem: RepoItem) {
    /**
     * @type {HashMap}
     */
    const fuidToRrnToScrubInfo = ThumbnailUtil.SCRUB_INFO_CACHE.get(repoItem.getBid());
    if (fuidToRrnToScrubInfo) {
      /**
       * @type {HashMap}
       */
      const rrnToScrubInfo = fuidToRrnToScrubInfo.get(repoItem.getFuid());
      if (rrnToScrubInfo) {
        /**
         * @type {HashMap}
         */
        const scrubInfo = rrnToScrubInfo.get(repoItem.getRrn());
        if (scrubInfo) {
          return scrubInfo;
        }
      }
    }
    return null;
  }

  /**
   *
   * @param repoItem{repoItem}
   * @return {*}
   */
  static storeScrubInfo(repoItem: RepoItem, scrubInfo: any) {
    /**
     * @type {HashMap}
     */
    let fuidToRrnToScrubInfo = ThumbnailUtil.SCRUB_INFO_CACHE.get(repoItem.getBid());
    if (!fuidToRrnToScrubInfo) {
      ThumbnailUtil.SCRUB_INFO_CACHE.put(repoItem.getBid(), (fuidToRrnToScrubInfo = new HashMap()));
    }
    /**
     * @type {HashMap}
     */
    let rrnToScrubInfo = fuidToRrnToScrubInfo.get(repoItem.getFuid());
    if (!rrnToScrubInfo) {
      fuidToRrnToScrubInfo.put(repoItem.getFuid(), (rrnToScrubInfo = new HashMap()));
    }
    rrnToScrubInfo.put(repoItem.getRrn(), scrubInfo);
  }

  /**
   * @param userName {String}
   * @returns {*}
   */
  static createUserAvatarUrl(userName: string) {
    return this.avatar(userName);
  }

  static GET_THUMB_URL_OLD() {
    return ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.GET_THUMB_URL_OLD_SUFFIX;
  }

  static GET_THUMB_URL() {
    if (System.isBrowserApp()) {
      return ConnectionUtil.getBaseUrl() + ThumbnailUtil.GET_THUMB_URL_Suffix;
    } else {
      return this.getClientThumbURL();
    }
  }

  static clientThumbnailURL: string = undefined;
  static getClientThumbURL() {
    if (!this.clientThumbnailURL) {
      this.clientThumbnailURL =
        ConnectionUtil.getBaseUrl() +
        ConnectionUtil.DESKTOP_CONTEXT +
        ConnectionUtil.SECURE_REMOTE_CALL_SUFFIX +
        '/clientapi/client_thumbnail';
    }
    return this.clientThumbnailURL;
  }

  static GET_DOWNLOAD_BASE() {
    return ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.MULTI_FORMAT_SERVLET;
  }

  static getDownloadBaseURL() {
    return ParamsUtil.appendAuthData(ThumbnailUtil.GET_DOWNLOAD_BASE());
  }

  static createDownloadJobIdUrl(): string {
    return ParamsUtil.appendOpcode(ThumbnailUtil.getDownloadBaseURL(), 'requestDownloadJob');
  }

  static downloadProgressUrl(jobId: number): string {
    const _url = ParamsUtil.appendAuthData(ThumbnailUtil.GET_THUMB_URL_OLD());
    return ParamsUtil.append(_url, { jobId: jobId });
  }

  static getDownlodPageUrl(): string {
    let pathname = System.isDesktop() ? '/webclient/' : location.pathname;
    return ConnectionUtil.getPreviewServerUrl() + pathname + ThumbnailUtil.DOWNLOAD_PAGE_URL;
  }

  static getSubtitleUrl(bid: number, fuid: number, rrn: number): string {
    let url = ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.SUB_TITLE_SUFFIX;
    url = ParamsUtil.append(url, { bid, fuid, rrn });
    return ParamsUtil.appendAuthData(url);
  }

  /**
   *@param {String} type Type to be passed to download Page
   *@param {String} displayName Display Name Of type to be shown on Download Type
   * @param {String} collectionName
   *@return{DownloadPageParams}
   */
  static setDownloadPageParams = (type: string, displayName: string, collectionName: string) => {
    const downloadPageParams = new DownloadPageParams();
    downloadPageParams.type = type;
    downloadPageParams.displayName = displayName;
    downloadPageParams.collectionName = collectionName;
    return downloadPageParams;
  };

  /**
   * Given URL is called with formData and on success open the download page
   * @param {String} url URL to call and on its reponse open the download page.
   * @param {DownloadPageParams} data Object of DownloadPageParams
   * @param {*} formData  JSON object which will go as FormData
   */
  static callUrlAndSwitchToDownloadPage(url: string, data: DownloadPageParams, formData: any = undefined) {
    const promise = ParamsUtil.submitAsFormUrlEncoded(url, formData);
    promise
      .then(function(json) {
        if (json.success) {
          if (!json.id) {
            return Promise.reject('Something went wrong');
          }
          ThumbnailUtil.switchToDownloadPage(json.id, data);
        } else {
          window.setError(json.error);
        }
      })
      .catch(function(error) {
        if (error.message) {
          window.setError(`Something went wrong with Preview Server - ${error.message} URL:${url}`);
        } else {
          const err = typeof error === 'object' ? JSON.stringify(error) : error;
          window.setError(err);
        }
      });

    /* ParamsUtil.submitAsFormUrlEncoded(url, )
    $.post(url, function (data) {
      if (data.success) {
        const downloadPageUrl = ConnectionUtil.getBaseUrl() + location.pathname + 'downloads/index.html?jobId=' + data.id + '&type=' + type;
        window.open(downloadPageUrl);
      } else {
        window.gs.error = data.error;
        window.render();
      }
    }).fail(function (e) {
      window.gs.error = JSON.stringify(e);
      window.render();
    }); */
  }

  static fetchDownloadJobId(url: string) {
    debug('[fetchDownloadJobId()] begin. url: ', url);
    return new Promise((resolve, reject) => {
      $.get(ParamsUtil.appendAuthData(url))
        .then((data) => {
          if (data.success) {
            if (data.id) {
              debug('[fetchDownloadJobId()] success. job id: ', data.id);
              return resolve(data.id);
            }
          }
          debug('[fetchDownloadJobId()] error. No job id. Response data: ', JSON.stringify(data));
          reject(data.error);
        })
        .catch((err) => {
          debug('[fetchDownloadJobId()] error: ', err);
          reject();
        });
    });
  }

  /**
   * Switch to download page by doing window.open
   * @param {number} jobId
   * @param {DownloadPageParams} params Download Page Params.
   */
  static switchToDownloadPage(jobId: number, params: DownloadPageParams) {
    params.isVABDesktop = System.isDesktop();
    params.theme = System.getTheme().getName();
    const url = ThumbnailUtil.getDownlodPageUrl();
    const data = this.encodeDownloadPageParams(jobId, params);
    const finalUrl = ParamsUtil.append(url, { data: data });
    if (System.isDesktop()) {
      window.open(finalUrl, 'download');
    } else {
      window.open(finalUrl, '_blank');
    }
  }

  /**
   *Encode Download Page Params
   * @param {string} jobId
   * @param {DownloadPageParams} params Download Page Params
   */

  static encodeDownloadPageParams(jobId: string, params: DownloadPageParams) {
    params.jobId = jobId;
    try {
      debug('[encodeDownloadPageParams()] Encoding the DownloadPageParams:', params);
      return btoa(JSON.stringify(params));
    } catch (error) {
      debug('[encodeDownloadPageParams()] error:', error);
    }
  }

  static switchToDownloadCollectionPage(url: string, type: string) {
    $.get(url, function(data) {
      if (data.success) {
        const downloadPageUrl =
          ConnectionUtil.getPreviewServerUrl() + location.pathname + 'downloads?jobId=' + data.id + '&type=' + type;
        window.open(downloadPageUrl);
      } else {
        window.setError(data.error);
      }
    }).fail(function(e) {
      window.setError(JSON.stringify(e));
    });
  }

  static appendRepoItem(url: string, repoItem: RepoItem): string {
    let link = ParamsUtil.appendFuidBidRrn(
      url,
      repoItem.getBid(),
      repoItem.getFuid(),
      repoItem.getRrn(),
      repoItem.getName()
    );
    if (repoItem.getRemotePath()) {
      link = ParamsUtil.append(link, { fqPath: repoItem.getRemotePath() });
    }
    return link;
  }

  static getAudioWaveFormUrl(repoItem: RepoItem): string {
    let url = ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.AUDIO_WAVE_FORM_URL;
    url = this.appendRepoItem(url, repoItem);
    url = ParamsUtil.appendAuthData(url);
    return url;
  }

  static createSubclipAndDownload(
    repoItem: RepoItem,
    start: number,
    end: number,
    ext: ?string,
    collectionId: ?number,
    type: ?string
  ) {
    debug('[createSubclipAndDownload()] begin');
    let url = ConnectionUtil.getPreviewServerUrl();

    url += ThumbnailUtil.SUBCLIP_DOWNLOAD_URL;

    url = this.appendRepoItem(url, repoItem);
    url = ParamsUtil.append(url, {
      start: Math.round(start),
      end: Math.round(end)
    });

    if (ext) {
      url = ParamsUtil.append(url, { ext });
    }

    if (collectionId) {
      url = ParamsUtil.append(url, { collectionId });
    }

    if (type) {
      url = ParamsUtil.append(url, { type });
    }

    url = ParamsUtil.appendAuthData(url);

    debug('[createSubclipAndDownload()] url: ', url);
    return injectIframe(url);
  }

  static createSubclipAndImport(
    repoItem: RepoItem,
    start: number,
    end: number,
    ext: ?string,
    collectionId: ?number,
    metadataSettings: ?(Object[]),
    ingest: boolean = true,
    type: 'clip' | 'fcp-xml' = 'clip'
  ): Promise<Object> {
    debug('[createSubclipAndImport()] begin');
    return new Promise((resolve, reject) => {
      let url = ConnectionUtil.getPreviewServerUrl();
      url += ingest ? ThumbnailUtil.SUBCLIP_IMPORT_URL : ThumbnailUtil.SUBCLIP_DOWNLOAD_URL;

      let httpVerb;
      let body;
      if (metadataSettings && metadataSettings.length) {
        httpVerb = 'post';
        body = this.appendRepoItem('', repoItem);
        body = ParamsUtil.append(body, { type: type });
        body = ParamsUtil.append(body, {
          metadataJson: JSON.stringify({ data: metadataSettings }),
          ext,
          poll: true
        });

        if (collectionId) {
          body = ParamsUtil.append(body, { collectionId });
        }
        body = ParamsUtil.appendAuthData(body);
        body = body.startsWith('?') ? body.substring(1) : body;
      } else {
        httpVerb = 'get';
        url = this.appendRepoItem(url, repoItem);
        url = ParamsUtil.append(url, {
          start: Math.round(start),
          end: Math.round(end),
          ext,
          poll: true
        });
        url = ParamsUtil.append(url, { type: type });

        if (collectionId) {
          url = ParamsUtil.append(url, { collectionId });
        }

        if (type) {
          ParamsUtil.append(url, { type: type });
        }

        url = ParamsUtil.appendAuthData(url);
      }

      debug('[createSubclipAndImport()] url: ', url);
      $[httpVerb](url, body)
        .then((data) => {
          if (!data.id) {
            throw new Error(data.message);
          }

          debug('[createSubclipAndImport()] success: ', data);
          resolve(data);
        })
        .catch((err) => {
          debug('[createSubclipAndImport()] error: ', err);

          if (!err.stack) {
            const { data, status, statusText } = err;
            err = new Error(data || `${status} - ${statusText}`);
          }

          reject(err);
        });
    });
  }

  static fetchVeritoneData(fuid: number): Promise<any> {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: ConnectionUtil.getPreviewServerUrl() + '/review/api/veritone/json/' + fuid,
        contentType: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        headers: ParamsUtil.createAuthHeaders(),
        type: 'GET'
      })
        .then((originalData: Object) => {
          if (!originalData || Object.keys(originalData).length === 0) {
            return resolve(null);
          }

          const data = {};
          let i = 0;
          Object.keys(originalData).forEach((key: string) => {
            let arr;
            try {
              if (key === 'objects') {
                arr = [originalData[key].data.engineResults.records];

                /**
                 * Object recognition data has overlapping nodes so we need to create multiple
                 * rows. The first row is the original data, which acts as a summary. Then on
                 * the timeline the user can expand the summary row to show the detail rows,
                 * which is the original data grouped by label.
                 */
                const labels = [];
                const tmpArr1 = [];
                arr[0][0].jsondata.series.forEach((o) => {
                  const { label } = o.object;
                  let index = labels.indexOf(label);
                  if (index === -1) {
                    labels.push(label);
                    tmpArr1.push([]);
                    index = labels.indexOf(label);
                  }
                  tmpArr1[index].push(o);
                });

                tmpArr1.sort((subarray1: Object[], subarray2: Object[]) => {
                  if (subarray1.length > subarray2.length) {
                    return -1;
                  }
                  if (subarray1.length < subarray2.length) {
                    return 1;
                  }
                  return 0;
                });

                const tmpArr2 = tmpArr1.slice(0, 20);
                tmpArr2.forEach((subarray: Object[]) => {
                  subarray.forEach((o: Object) => (o.id = ++i));
                });

                arr = arr.concat(tmpArr2);
              } else {
                arr = originalData[key].data.engineResults.records;
                arr[0].jsondata.series.forEach((o) => (o.id = ++i));
              }

              data[key] = arr;
            } catch (error) {
              console.warn(error);
            }
          });

          const metadata = HashMap.fromObject(data);
          resolve(metadata);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  /**
   * 1.used to delete files/folders
   * @param assetArray Array<RepoItem> having file/folder
   * @return {Promise.<FlexZoomCommandResponse>}
   */

  static deleteFilesOrFolders(assetArray: Array<RepoItem>): Promise<FlexZoomCommandResponse> {
    const query: FlexDelete = new FlexDelete(asset, newName);
    return new Promise((resolve, reject) => {
      query
        .run()
        .then((resp) => {
          debug('[deleteFilesOrFolders()] resp: ', resp);
          resolve(resp);
        })
        .catch((error) => {
          debug('[deleteFilesOrFolders()] error: ', error);
          reject(error);
        });
    });
  }

  /**
   *
   * @param asset RepoItem which is to be renamed
   * @param newName New name of asset
   * @return {Promise.<T>}
   */

  static renameFileOrFolders(asset: RepoItem, newName: string): Promise<FlexZoomCommandResponse> {
    const query: FlexRemoteRename = new FlexRemoteRename(asset, newName);
    return new Promise((resolve, reject) => {
      query
        .run()
        .then((resp) => {
          debug('[renameFileOrFolders()] resp: ', resp);
          resolve(resp);
        })
        .catch((error) => {
          debug('[renameFileOrFolders()] error: ', error);
          reject(error);
        });
    });
  }

  /**
   *
   * @param assetsArray array of RepoItem having files/folders
   * @param destFuid  Fuid of Destination folder
   * @param metadataMap metadata Map of asset
   * @return {Promise.<T>}
   */

  static moveFilesOrFolder(
    assetsArray: Array<RepoItem>,
    destFuid: number,
    metadataMap: ?HashMap<String, String> = null
  ): Promise<FlexZoomCommandResponse> {
    const query: FlexRemoteMove = new FlexRemoteMove(assetsArray, destFuid, metadataMap);
    return new Promise((resolve, reject) => {
      query
        .run()
        .then((resp) => {
          debug('[moveFilesOrFolder()] resp: ', resp);
          resolve(resp);
        })
        .catch((error) => {
          debug('[moveFilesOrFolder()] error: ', error);
          reject(error);
        });
    });
  }

  static computeRemotePathOfAssets(assets: Array<RepoItem>): Array<string> {
    return assets.map((asset) => {
      if (!asset.getRemotePath()) {
        const sourcePath: string = getRemotePathFromBreadcrumb();
        return `${sourcePath}/${asset.getName()}`;
      } else {
        return asset.getRemotePath();
      }
    });
  }

  static isFolder(assetPath: string) {
    if (assetPath && assetPath.lastIndexOf('/') > -1) {
      const assetName = assetPath.substring(assetPath.lastIndexOf('/') + 1, assetPath.length);
      if (assetName && assetName.lastIndexOf('.') <= -1) {
        return true;
      }
    }
    return false;
  }

  static getAssetPathFuids(fuids: number[], isFetchRepoItem): GetAssetsPathFuidsResponse {
    const query: GetAssetsPathFuidsQuery = new GetAssetsPathFuidsQuery();
    const msg: GetAssetsPathFuidsMessage = new GetAssetsPathFuidsMessage();
    msg.setFetchDetailsForPathFuids(isFetchRepoItem);
    msg.setFuids(fuids);
    query.message = msg;
    return new Promise((resolve, reject) => {
      query
        .run()
        .then((resp) => {
          debug('[getAssetPathFuids()] res: ', resp);
          resolve(resp);
        })
        .catch((error) => {
          debug('[getAssetPathFuids()] error: ', error);
          reject(error);
        });
    });
  }

  static SUB_TITLE_SUFFIX: string;
  static H264_PREVIEW_URL: string;
  static IMAGE_PREVIEW_URL: string;
  static JOB_STATUS_URL: string;
  static GET_THUMB_URL_OLD_SUFFIX: string;
  static GET_THUMB_URL_Suffix: string;
  static MULTI_FORMAT_SERVLET: string;
  static AUDIO_WAVE_FORM_URL: string;
  static DEFAULT_RESOLUTION: number;
  static SCRUB_INFO_CACHE: HashMap;
  static SUBCLIP_DOWNLOAD_URL: string;
  static SUBCLIP_IMPORT_URL: string;

  static AVATAR_UPLOAD_PATH: string;
  static RECOVER_PASSWORD_URL: string;
}

ThumbnailUtil.SCRUB_INFO_CACHE = new HashMap();
ThumbnailUtil.AVATAR_UPLOAD_PATH = '/webclient/api/unsecure/avatar-upload';
ThumbnailUtil.DEFAULT_RESOLUTION = 1920;

ThumbnailUtil.SUB_TITLE_SUFFIX = '/review/api/video/preview/subtitle'; //Prefix preview server origin. i.e ConnectionUtil.getBaseUrl() and append auth data then send this cal.
ThumbnailUtil.H264_PREVIEW_URL = '<%=previewServer%>/review/api/video/preview';
ThumbnailUtil.IMAGE_PREVIEW_URL = '<%=previewServer%>/review/api/image/preview';
ThumbnailUtil.JOB_STATUS_URL = '<%=previewServer%>/review/api/context/job';
//ThumbnailUtil.GET_THUMB_URL = "http://127.0.0.1:7770/webmin/zoomwebclient-remoting/rest/thumbnail";
ThumbnailUtil.GET_THUMB_URL_OLD_SUFFIX = '/review/preview/assetPreview';
ThumbnailUtil.GET_THUMB_URL_Suffix = '/review/api/thumb';
ThumbnailUtil.MULTI_FORMAT_SERVLET = '/review/jsp/download/downloadAsset.jsp';
ThumbnailUtil.AUDIO_WAVE_FORM_URL = '/review/api/audio/waveform';
ThumbnailUtil.SUBCLIP_DOWNLOAD_URL = '/review/api/clip';
ThumbnailUtil.SUBCLIP_IMPORT_URL = '/review/api/clip/import';
ThumbnailUtil.RECOVER_PASSWORD_URL = '/review/api/unsecure/recover-password';

export const asyncCallForGetUserName = function(userId) {
  ThumbnailUtil.loadUserFullName(userId)
    .then()
    .catch(_.noop);
};

export const getImageBase64FromUrl = function(repo: RepoItem): Promise {
  const url = ThumbnailUtil.createThumbUrl(repo);
  const imageElement = new Image();
  imageElement.src = url;
  return new Promise((resolve, reject) => {
    imageElement.onload = function() {
      var canvas = document.createElement('canvas');
      var heightRatio = imageElement.height / imageElement.width;
      var targetWidth = 80;
      canvas.width = targetWidth;
      canvas.height = targetWidth * heightRatio;

      var ctx = canvas.getContext('2d');
      ctx.drawImage(
        imageElement,
        0,
        0,
        imageElement.width,
        imageElement.height,
        0,
        0,
        targetWidth,
        targetWidth * heightRatio
      );
      var dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    imageElement.onerror = function() {
      reject('');
    };
  });
};
